module.exports = __webpack_public_path__ + "img/box.d36307db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/box.svg
// module id = tr04
// module chunks = 1